import { Helmet } from "react-helmet"
import happyImage from '../../assets/images/happyhour.png'

export default function Specials(){
  return (
    <div className="pageStyles happy-hour">
      <Helmet>
        <title>Happy Hour in Orange Beach, AL | Villaggio Grille</title>
        <meta name="description" content="Join Villaggio for Happy Hour Celebrations!" />
      </Helmet>

      <div id="happyhour-page">
        <div className="simpleBanner"><h1>Enjoy Our Amazing Specials!</h1></div>
        <div className="mainWrap">
          <div className="sectionWrap medDef">
            <div className="fullSec">
              <img src={happyImage} alt="Villaggio's happy hour menu" className="hhImg" />
              <div className="clearfix"></div><hr />
              <p className="col-md-12 textCenter nocap" style={{marginTop:'15px'}}><b>*Coupons can not be applied.</b></p>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-12"><div className="hr hr-png-10"></div></div>
    </div>
  )
}

